<template>
  <div>
    <b-modal
      id="modal-multi-3"
      title="Peticion"
      ok-only
      ok-title="Accept"
      v-model="$store.state.someVariables.showNewTarea"
    >
      <b-card no-body style="padding:5px;margin-bottom:5px !important">
        <b-row>
          <b-col md="12">
            <v-select
              :options="listEntidades"
              placeholder="Seleccione Cliente"
              :clearable="false"
              v-model="tarea.entidadSeleccionada"
              :disabled="accion == 'i' ? false : true"
              @input="changeEntidad"
              style="display:none"
            />
          </b-col>
        </b-row>
        <b-row style="display:none" v-if="accion == 'u'" class="mt-1">
          <b-col md="12">
            <v-select
              :options="listEstados"
              placeholder="Seleccione Estado"
              :clearable="false"
              v-model="tarea.estadoSeleccionada"
            />
          </b-col>
        </b-row>
        <b-form>
          <vue-autosuggest
            style="margin-top:10px;display:none"
            :suggestions="filteredOptionsItems"
            :limit="10"
            :input-props="{
              id: 'autosuggest__input',
              class: 'form-control',
              placeholder: 'Ingrese solicitante',
              disabled: accion == 'i' ? false : true,
            }"
            @input="onInputChange"
            v-model="tarea.solicitante"
            :disabled="accion == 'i' ? false : true"
          >
            <template slot-scope="{ suggestion }">
              <span class="mi-item">{{ suggestion.item.name }} </span>
            </template>
          </vue-autosuggest>
          <br />

          <label for="textarea-default">Describir petición</label>
          <b-form-textarea
            v-model="tarea.descripcion"
            id="textarea-default"
            placeholder="Ingrese petición "
            rows="6"
          />
          <br />
          <b-form-file
            v-if="tarea.id_estado == 1"
            v-model="fileModel"
            placeholder="Selecciona el/los archivos "
            drop-placeholder="Arrastra tus archivos..."
            multiple
          />
          <div
            v-if="tarea.archivos.length != 0"
            style="margin-top:10px;color: cornflowerblue;font-size: 12px;"
          >
            Archivos adjuntos
          </div>
          <div v-for="item in tarea.archivos" :key="item.id_archivo">
            <feather-icon
              v-if="tarea.id_estado == 1"
              icon="TrashIcon"
              class="cursor-pointer mx-1"
              size="14"
              style="color:red"
              @click="deleteArchivo(item)"
            />
            <span
              @click="openArchivo(item)"
              style="text-decoration:underline; cursor:pointer;color:gray;padding:4px;color: #919bae;font-size:11px"
              >{{ item.path }}</span
            >
          </div>
          <div style="font-size:11px; background:yellow">
            No olvides dejar tu número de telefóno al final de la petición para
            de ser el caso comunicarnos contigo
          </div>
          <!-- <template v-if="accion == 'u'">
            <label style="margin-top:20px " for="textarea-default"
              >Describir observación</label
            >
            <b-form-textarea
              v-model="tarea.observacion"
              id="textarea-default"
              placeholder="Ingrese observación(para enviar un mensaje al solicitante) "
              rows="3"
            />
          </template> -->
        </b-form>
      </b-card>
      <template #modal-footer>
        <div class="w-100">
          <template v-if="!showLoading">
            <b-button
              v-if="tarea.id_estado == 1"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              @click="uploadPeticion"
            >
              <span v-if="accion == 'i'">Guardar</span>
              <span v-else>Actualizar</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="float-right mr-1"
              @click="onlyClose"
            >
              Cancelar
            </b-button>
          </template>
          <div v-if="showLoading" class="text-center mt-1">
            <b-spinner variant="primary" label="Text Centered" />
            <span>por favor espera, esto puede tardar unos segundos</span>
          </div>
          <b-alert
            :show="dismissCountDown"
            v-height-fade.appear
            :variant="variante"
            style="position:absolute; bottom:55px;  width:92%; margin-left:-4px ;z-index:100"
            @dismiss-count-down="countDownChanged"
          >
            <div
              :class="{
                'alert-body danger': variante == 'danger',
                'alert-body success': variante == 'success',
              }"
            >
              {{ messageError }}
            </div>
          </b-alert>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select'
import {
  BFormCheckbox,
  BCard,
  BCardBody,
  BOverlay,
  BTabs,
  BTab,
  VBPopover,
  BPopover,
  BModal,
  BForm,
  BFormInput,
  BFormTextarea,
  BButton,
  BFormFile,
  //   // BAvatar,
  //   // BBadge,
  BRow,
  BCol,
  BAlert,
  BSpinner,
  //   //   xxxx,
  //   //   ssss,
} from 'bootstrap-vue'
import store from '@/store'
import { VueAutosuggest } from 'vue-autosuggest'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import {
  ref,
  // onMounted,
  // computed,
  // watch,
  // watchEffect,
} from '@vue/composition-api'
// import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  URL_PDF,
  URL_ADMINISTRACION,
  URL_DOCS_PETICIONES,
  //   USER,
  //   ROLES,
  // xx
} from '../../utils/variables'

export default {
  components: {
    //   BTable,
    BFormFile,
    VueAutosuggest,
    BFormCheckbox,
    BCard,
    BCardBody,
    vSelect,
    BOverlay,
    BTabs,
    BTab,
    BPopover,
    BForm,
    BFormInput,
    BFormTextarea,
    BSpinner,
    //   // BAvatar,
    //   // BBadge,
    BRow,
    BCol,
    BModal,
    BButton,
    BAlert,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
    heightFade,
  },
  props: {
    listEntidades: Array,
    listEstados: Array,
    accion: String,
    tarea: Object,
    // showLoading: Boolean,
  },
  setup(props, { emit }) {
    const { postApiFormData, postApi, getApi } = apiCall()
    const showLoading = ref(false)
    const entidadSeleccionada = ref(null)
    const estadoSeleccionada = ref(null)
    const dataSolicitud = ref({})
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    const hasError = ref(false)
    const variante = ref('danger')
    const fileModel = ref(null)
    const filteredOptions = ref([
      { nombre: 'juan' },
      { nombre: 'pedro' },
      { nombre: 'andres' },
      { nombre: 'roserp' },
    ])
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    const filteredOptionsItems = ref([])
    function openArchivo(item) {
      window.open(`${URL_DOCS_PETICIONES}${item.path}`, '_blank')
    }
    function hasErrorForm() {
      // console.log(props.tarea)
      let error = false
      // console.log(dataNoticia)
      if (props.tarea.entidadSeleccionada === null) {
        showMessageAlert('danger', 'Seleccione el cliente')
        error = true
      } else if (props.tarea.estadoSeleccionada === null) {
        showMessageAlert('danger', 'Seleccione el estado')
        error = true
      } else if (
        props.tarea.solicitante === '' ||
        props.tarea.solicitante == null
      ) {
        showMessageAlert('danger', 'Ingrese el solicitante')
        error = true
      } else if (
        props.tarea.descripcion === '' ||
        props.tarea.descripcion == null
      ) {
        showMessageAlert('danger', 'Petición no debe ser vacío')
        error = true
      }
      //  else if (errorTipo()) {
      //   error = true
      // }
      return error
    }
    async function changeEntidad() {
      filteredOptions.value = []
      const path = `ApiClientes/getSolicitantes/${props.tarea.entidadSeleccionada.value}`
      const response = await getApi(URL, path)
      filteredOptions.value = response.data
    }
    function clearForm() {
      // props.tarea.solicitante = null
      // props.tarea.entidadSeleccionada = null
      props.tarea.descripcion = null
      const estadoSeleccionadaAux = {
        value: 1,
        label: 'Esperando revisión',
      }
      props.tarea.estadoSeleccionada = estadoSeleccionadaAux
      fileModel.value = null
    }
    async function deleteArchivo(item) {
      const path = 'ApiClientes/deleteArchivo'
      const data = {
        id_archivo: item.id_archivo,
        path: item.path,
      }
      const response = await postApi(URL_ADMINISTRACION, path, data)
      if (response.flag == 'si') {
        const found = props.tarea.archivos.findIndex(
          // eslint-disable-next-line
          element => element.id_archivo === item.id_archivo
        )
        props.tarea.archivos.splice(found, 1)
        emit('recargar')
      }
    }
    async function uploadPeticion() {
      // console.log(fileModel.value)
      if (!hasErrorForm()) {
        showLoading.value = true
        const archivo = new FormData()
        // console.log(dataNoticia)
        if (fileModel.value != null) {
          fileModel.value.forEach((file, index) => {
            archivo.append(`file[]`, file) // Usamos "file[]" para múltiples archivos
          })
        }

        archivo.append('solicitante', props.tarea.solicitante)
        archivo.append('id_cliente', props.tarea.entidadSeleccionada.value)
        archivo.append('peticion', props.tarea.descripcion)
        archivo.append('id_estado', props.tarea.estadoSeleccionada.value)
        archivo.append('id_atiende', USER().id_usuario)
        archivo.append('observacion', props.tarea.observacion)
        archivo.append('accion', props.accion)
        archivo.append('id_peticion', props.tarea.id_peticion)
        const path = 'ApiClientes/insertPeticion'
        const response = await postApiFormData(
          URL_ADMINISTRACION,
          path,
          archivo
        )
        if (response.flag === 'si') {
          showMessageAlert('success', 'Insertado exitosamente')

          emit('recargar')
          clearForm()
        }
        showLoading.value = false
      }
    }
    function onlyClose() {
      store.commit('someVariables/UPDATE_SHOW_NEW_TAREA', false)
      showLoading.value = false
    }
    function onInputChange(text) {
      // console.log(filteredOptions.value)
      const filteredDevelopers = filteredOptions.value
        .filter(
          item => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1
        )
        .slice(0, 10)
      // console.log(filteredDevelopers)
      filteredOptionsItems.value = [{ data: filteredDevelopers }]
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    return {
      showLoading,
      entidadSeleccionada,
      dataSolicitud,
      filteredOptions,
      onInputChange,
      filteredOptionsItems,
      dismissCountDown,
      dismissSecs,
      messageError,
      variante,
      uploadPeticion,
      onlyClose,
      countDownChanged,
      estadoSeleccionada,
      fileModel,
      openArchivo,
      deleteArchivo,
      changeEntidad,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

// #autosuggest-autosuggest__results{
//   background: gainsboro;
//   cursor:pointer;
// }
// .mi-item {
// margin-top: 10px;
// color: red;
// }
// .vue-autosuggest__suggestion
// {
//   color: red;
// }
.autosuggest__results ul {
  background: rgb(242, 240, 240);
  list-style-type: none;
  position: absolute;
  width: 98%;
  z-index: 10000;
  padding-top: 10px;
  padding-left: 0px;
}
.autosuggest__results ul li {
  padding: 6px;
  cursor: pointer;
  padding-left: 20px;
}
.autosuggest__results ul :hover {
  background: rgb(230, 229, 229);
  cursor: pointer;
}
</style>
